import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// Components
import { SkyscraperAd } from 'dibs-google-ad-manager/exports/SkyscraperAd';

// Helpers
import { getSkyscraperAdData } from 'dibs-google-ad-manager/exports/adHelpers';

import { type SbSharedSkyscraperAd_itemSearch$key } from './__generated__/SbSharedSkyscraperAd_itemSearch.graphql';

const itemSearchFragment = graphql`
    fragment SbSharedSkyscraperAd_itemSearch on ItemSearchQueryConnection {
        displayUriRef
    }
`;

type Props = {
    itemSearch: SbSharedSkyscraperAd_itemSearch$key;
};

export const SbSharedSkyscraperAd: FC<Props> = ({ itemSearch: itemSearchRef }) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const displayUriRef = itemSearch?.displayUriRef ?? '';
    const skyscraperAdData = getSkyscraperAdData(displayUriRef);

    if (!skyscraperAdData) {
        return null;
    }

    return <SkyscraperAd {...skyscraperAdData} />;
};
